module.exports = __webpack_public_path__ + "static/media/tti_privacy_keeping.5bd080ec.png";